import CdService from '@/services/cd.service'

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// TODO: Move in localstorage (reverseSidebar, fullscreen)
export default new Vuex.Store({
  state: {
    order: {
      subtotal: 0,
      grand_total: 0,
      tax_total: 0,
      discount_total: 0,
      pay_total: 0,
      items: [],
      surcharge_value: 0
    },
    pos: {
      id: CdService.getPosId(),
      is_connected: null
    },
    cd_is_open: false,
    reverseSidebar: CdService.getReverseSidebarStatus(),
    fullscreen: CdService.getFullscreenStatus(),
    sale: {
      transactionAmount: 0.00,
      changeTenderAmount: 0.00
    },
    isSale: false,
    terminalId: null
  },
  getters: {
    order: (state) => state.order,
    orderItems: (state) => state.order.items.filter(item => !item.void_status),
    posIsConnected: (state) => state.pos.is_connected,
    cdIsOpen: (state) => state.cd_is_open,
    reverseSidebar: (state) => state.reverseSidebar,
    fullscreen: (state) => state.fullscreen,
    sale: (state) => state.sale,
    isSale: (state) => state.isSale,
    terminalId: (state) => state.terminalId
  },
  actions: {
    setOrder: ({commit}, payload) => commit('SET_ORDER', payload),
    setPosIsConnected: ({commit}, payload) => commit('SET_POS_IS_CONNECTED', payload),
    setCdIsOpen: ({commit}, payload) => commit('SET_CD_IS_OPEN', payload),
    setReverseSidebar ({commit}, payload) {
      CdService.saveReverseSidebarStatus(payload)
      commit('SET_REVERSE_SIDEBAR', payload)
    },
    setFullscreen ({commit}, payload) {
      CdService.saveFullscreenStatus(payload)
      commit('SET_FULLSCREEN', payload)
    },
    setSaleDetails ({ commit }, saleDetails) {
      commit('SET_SALE', saleDetails)
    },
    setIsSale ({ commit }, isSale) {
      commit('SET_ISSALE', isSale)
    },
    setTerminalId ({ commit }, terminalId) {
      commit('SET_TERMINAL_ID', terminalId)
    }
  },
  mutations: {
    SET_ORDER: (state, value) => {
      // Merge incoming order with default values to prevent undefined properties
      state.order = {
        subtotal: (value && value.subtotal) || 0,
        grand_total: (value && value.grand_total) || 0,
        tax_total: (value && value.tax_total) || 0,
        discount_total: (value && value.discount_total) || 0,
        pay_total: (value && value.pay_total) || 0,
        items: (value && value.items) || [],
        surcharge_value: (value && value.surcharge_value) || 0
      }
    },
    SET_POS_IS_CONNECTED: (state, value) => { state.pos.is_connected = value },
    SET_CD_IS_OPEN: (state, value) => { state.cd_is_open = value },
    SET_REVERSE_SIDEBAR: (state, value) => { state.reverseSidebar = value },
    SET_FULLSCREEN: (state, value) => { state.fullscreen = value },
    SET_SALE: (state, sale) => { state.sale = sale },
    SET_ISSALE: (state, isSale) => { state.isSale = isSale },
    SET_TERMINAL_ID: (state, terminalId) => { state.terminalId = terminalId }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js